import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from "@mui/material";
import axios, { AxiosError } from "axios";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { queryClient } from "../App";
import { API_URL } from "../consts";

interface Data {
  email: string;
}
interface CreateBackOffice {
  email: string;
  password: string;
}

export function BackOffice() {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");

  const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };
  const handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };
  const handleChangePassword2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword2(event.target.value);
  };

  const { isLoading, data } = useQuery<unknown, AxiosError, { backOffice: Data[] }>(
    ["users/getBackOffice"],
    () => axios.get(API_URL + "users/getBackOffice").then((res) => res.data)
  );

  const { mutate } = useMutation(
    (data: CreateBackOffice) => {
      return axios.post(API_URL + "users/createBackOffice", data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Back Office creato", { variant: "success" });
        handleClose();
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const handleSubmit = () => {
    if (password !== password2)
      enqueueSnackbar("Le password devono essere uguali!", { variant: "error" });
    else {
      const data = {
        email,
        password,
      };
      mutate(data);
    }
  };

  return (
    <>
      <Button color="secondary" onClick={handleClickOpen}>
        Aggiungi Back Office
      </Button>
      <TableContainer>
        <Table size="small">
          {!isLoading &&
            data?.backOffice.map((e) => (
              <TableRow>
                <TableCell>{e.email}</TableCell>
              </TableRow>
            ))}
        </Table>
      </TableContainer>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Aggiungi Back Office</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Email"
            type="email"
            fullWidth
            variant="standard"
            value={email}
            onChange={handleChangeEmail}
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Password"
            type="password"
            fullWidth
            variant="standard"
            value={password}
            onChange={handleChangePassword}
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Ripeti Password"
            type="password"
            fullWidth
            variant="standard"
            value={password2}
            onChange={handleChangePassword2}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit} autoFocus>
            Aggiungi
          </Button>
          <Button onClick={handleClose} autoFocus>
            Chiudi
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
